import React, { useState } from 'react';
import { X, Plus } from 'lucide-react';

export default function TagInput({ values, onChange, placeholder = 'Add item…' }) {
  const [input, setInput] = useState('');

  const add = () => {
    const v = input.trim();
    if (v && !values.includes(v)) onChange([...values, v]);
    setInput('');
  };

  const remove = (item) => onChange(values.filter(v => v !== item));

  return (
    <div>
      <div className="flex flex-wrap gap-1.5 mb-2">
        {values.map(v => (
          <span key={v} className="flex items-center gap-1 bg-blue-50 text-blue-700 text-xs px-2 py-1 rounded-full">
            {v}
            <button type="button" onClick={() => remove(v)} aria-label={`Remove ${v}`} className="p-1 min-w-[24px] min-h-[24px] flex items-center justify-center hover:text-red-500 rounded">
              <X size={11} aria-hidden="true" />
            </button>
          </span>
        ))}
      </div>
      <div className="flex gap-2">
        <input
          type="text" value={input} placeholder={placeholder}
          onChange={e => setInput(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); add(); } }}
          className="flex-1 border border-gray-300 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder:text-gray-500"
        />
        <button type="button" onClick={add}
          className="flex items-center gap-1 bg-blue-600 text-white px-3 py-1.5 rounded-lg text-sm hover:bg-blue-700">
          <Plus size={14} aria-hidden="true" /> Add
        </button>
      </div>
    </div>
  );
}
